// extracted by mini-css-extract-plugin
module.exports = {"switcher":"switcher_switcher__2zHI-","spinner":"switcher_spinner__4W3El","load3":"switcher_load3__1U79n","notFound":"switcher_notFound__1iznC"};